import { render } from "./OffersItemSlider.vue?vue&type=template&id=5127994e&scoped=true"
import script from "./OffersItemSlider.vue?vue&type=script&lang=js"
export * from "./OffersItemSlider.vue?vue&type=script&lang=js"

import "./OffersItemSlider.vue?vue&type=style&index=0&id=5127994e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5127994e"

export default script